import { render } from "./AppSubmenu.vue?vue&type=template&id=4fd70adb&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4fd70adb"

export default script